import { Box, Button, Card, CardActions, CardContent, Chip, Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { EquipmentChargeType, EquipmentChargeTypeStringOfValue, EquipmentData } from "../../Objects/EquipmentData";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";

export interface EquipmentCardProps {
    equipmentData: EquipmentData
    onEdit?: (equipmentData: EquipmentData) => void
    onRepair?: (equipmentData: EquipmentData) => void
    onDelete?: (equipmentData: EquipmentData) => void
}

const EquipmentCard: React.FC<EquipmentCardProps> = ({
    equipmentData,
    onEdit,
    onRepair,
    onDelete,
}) => {
    let { enqueueSnackbar } = useSnackbar()

    const { storeObjectState } = React.useContext(StoreObjectStore)

    return (
        <Card
            sx={{
                height: "100%"
            }}
        >
            <CardContent>
                <Stack
                    spacing={1}
                >
                    <Stack
                        direction="row"
                        spacing={1}
                    >
                        {equipmentData.delete_flug &&
                            <Chip
                                label="削除済みアイテム"
                                size="small"
                                color="error"
                                variant="outlined"
                            />
                        }
                        {equipmentData.repaired_flug &&
                            <Chip
                                label="修理中"
                                size="small"
                                color="error"
                            />
                        }
                        {equipmentData.rental_flug &&
                            <Chip
                                label="レンタル機材"
                                size="small"
                                color="info"
                                variant="outlined"
                            />
                        }
                    </Stack>
                    <Stack>
                        <Typography>
                            {equipmentData.equ_shortened &&
                                <Chip
                                    component="span"
                                    label={equipmentData.equ_shortened}
                                    size="small"
                                    sx={{
                                        mr: 1,
                                    }}
                                />
                            }
                            {equipmentData.equ_name}
                        </Typography>
                        <Typography variant="body2">
                            {equipmentData.equ_maker}  <Typography variant="body2" component="span" sx={{ opacity: 0.8 }}>{equipmentData.equ_model}</Typography>
                        </Typography>
                    </Stack>
                    <Stack
                        direction="row"
                        flexWrap="wrap"
                    >
                        {storeObjectState.studioList?.map(studioData => {
                            if (studioData.std_id && equipmentData.available_studio_ids && equipmentData.available_studio_ids.includes(studioData.std_id)) {
                                return (
                                    <Chip
                                        variant="outlined"
                                        key={studioData.std_id}
                                        label={studioData.std_name}
                                        size="small"
                                    />
                                )
                            }
                            return null
                        })}
                    </Stack>
                    {equipmentData.equ_charge_type &&
                        <Box>
                            {equipmentData.equ_charge_type == EquipmentChargeType.null ? (
                                <Typography variant="body2">無料機材</Typography>
                            ) : (
                                <>
                                    <Typography variant="body2">{EquipmentChargeTypeStringOfValue[equipmentData.equ_charge_type]} {equipmentData.equ_charge?.toLocaleString()}円</Typography>
                                    <Typography variant="body2">{equipmentData.equgrp_id && `「${equipmentData.equgrp_name}」グループの中で1台無料`}</Typography>
                                </>
                            )}
                        </Box>
                    }
                </Stack>
            </CardContent>
            {!equipmentData.delete_flug &&
                <CardActions>
                    {onEdit &&
                        <Button
                            variant="outlined"
                            onClick={() => {
                                onEdit(equipmentData)
                            }}
                        >編集</Button>
                    }
                    {onRepair &&
                        <Button
                            variant="outlined"
                            onClick={() => {
                                onRepair(equipmentData)
                            }}
                        >{equipmentData.repaired_flug ? "修理完了登録" : "修理登録"}</Button>
                    }
                    {onDelete &&
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                onDelete(equipmentData)
                            }}
                        >削除</Button>
                    }
                </CardActions>
            }
        </Card>
    )
}

export default EquipmentCard